var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.content),function(block,i){return _c(block.acf_fc_layout,{key:i + 1,tag:"component",staticClass:"content-section",attrs:{"content":block.content}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }